export const Drawer = {
  parts: ['dialog', 'body', 'header'],
  baseStyle: {
    dialog: {
      bg: 'brand.front'
    },
    body: {
      p: 0,
      overflow: 'auto',
      maxH: 'full'
    },
    header: {
      py: 2,
      minH: '12',
      pr: '48px'
    }
  }
}
